<app-stage
  title="Das ist SYMBOX!"
  subtitle="SYMBOX liefert Internet und Telefonie zuverlässig aus einer Hand – mit modernster, zukunftsfähiger Glasfasertechnologie. SYMBOX ist ein Unternehmen der inexio mit eigenem Glasfasernetz über Tausende von Kilometern hinweg – und ist damit nicht nur Anbieter, sondern gleichzeitig auch Netzeigentümer, der seine Angebote unabhängig von Dritten gestalten und steuern kann. Wir bieten Ihnen Anschlüsse, die mit steigenden Anforderungen mitwachsen."
  imageSrc="assets/images/stage_image.webp"
  imageAlt="Gebäudekomplexe vor blauen Himmel mit Textbox: Symbox zieht mit ein! Bei Ihnen auch?" />

<app-tariff-carousel></app-tariff-carousel>
